import { render, staticRenderFns } from "./CompanyMobileGroupOrderers.vue?vue&type=template&id=1fd34675"
import script from "./CompanyMobileGroupOrderers.vue?vue&type=script&lang=js"
export * from "./CompanyMobileGroupOrderers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports